@if (isActive()) {
  <div
    cdkOverlay
    class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"
    (click)="closeModule()"
    [@fadeInOut]
  ></div>
  <div
    class="account-mobile"
    [@slideInOut]
    role="dialog"
    aria-modal="true"
    tabindex="-1"
  >
    <div #accountContent class="account-content" cdkScrollable>
      <div class="account-top">
        <div class="account-top-buttonBox">
          <button
            #closeButton
            class="account-top-close-button"
            [attr.aria-label]="'common.close' | transloco"
            (click)="closeModule()"
          >
            <img
              class="account-top-icon"
              alt=""
              src="assets/images/misc/close.svg"
            />
          </button>
        </div>
      </div>

      <div class="account-items">
        @switch (boelsUser().type) {
          @case (userType.B2C_AUTHENTICATED) {
            @for (item of menuItemsList; track $index) {
              @if (
                (item.shouldHaveDebtorData && boelsUser().debtor?.name) ||
                !item.shouldHaveDebtorData
              ) {
                <div
                  class="account-item"
                  role="menuitem"
                  tabindex="0"
                  (click)="menuItemClicked(item, $event)"
                  (keydown)="handleMenuItemKeyDown(item, $event)"
                  [attr.aria-label]="
                    item.title
                      ? (item.title | transloco)
                      : (item.subtitle | transloco)
                  "
                >
                  <div class="account-item-content">
                    @if (item.icon) {
                      <fa-icon
                        class="account-item-icon"
                        [ngClass]="item.iconClass"
                        [icon]="item.icon"
                      ></fa-icon>
                    } @else if (item.imgSrc) {
                      <img
                        class="account-item-icon"
                        [ngClass]="item.iconClass"
                        [src]="item.imgSrc"
                        [alt]="item.subtitle | transloco"
                        loading="lazy"
                      />
                    }
                    <div class="account-item-text">
                      @if (item.title) {
                        <span
                          class="account-item-title"
                          boelsQa="menu-item-title"
                        >
                          {{ item.title | transloco }}
                        </span>
                      }
                      @if (item.subtitle || item.subtitleBinding) {
                        <span
                          class="account-item-subtitle"
                          boelsQa="menu-item-subtitle"
                          >{{
                            item.subtitleBinding
                              ? getSubtitle(item.subtitleBinding)
                              : (item.subtitle | transloco)
                          }}</span
                        >
                      }
                      @if (item.showLanguageSelector) {
                        <boels-toggle-language-selector
                          class="account-item-language-selector"
                          boelsQa="menu-item-subtitle"
                          [textOnly]="true"
                          [cssClassForText]="'account-item-subtitle'"
                        ></boels-toggle-language-selector>
                      }
                    </div>
                  </div>
                </div>
              }
            }
          }
          @default {
            <div class="account-item" (click)="login.emit()">
              <div class="account-item-content">
                <boels-login-indicator
                  (loginClicked)="login.emit()"
                  (keydown.enter)="login.emit()"
                  tabindex="0"
                ></boels-login-indicator>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
}
